import type { CreateCexDataDefaultParameters } from '../../types'
import { createCexData } from '../../utils/createCexData'
import { fetchDepositHistories } from './fetchData'
import { parseDepositHistoriesToAccountIds } from './parseToAccountIds'
import { parseDepositHistoriesToActions } from './parseToActions'
import { parseDepositHistoriesToSources } from './parseToSources'
import type { Deposit } from './schema'

const limit = 500

export const createKucoinDepositHistoryData = async (
  parameters: Omit<CreateCexDataDefaultParameters, 'limit' | 'desc'>,
) =>
  createCexData<Deposit>({
    ...parameters,
    limit,
    desc: true,
    fetchAllData: async (parameters) => {
      if (parameters.password === undefined) {
        throw new Error('password is required')
      }
      const data = await fetchDepositHistories({
        ...parameters,
        password: parameters.password,
        limit,
      })

      // sort
      const sortedData = data.toSorted((a, b) => a.createdAt - b.createdAt)
      return {
        data: sortedData,
        from: sortedData.length > 0 ? sortedData[0].createdAt : undefined,
        to:
          sortedData.length > 0
            ? sortedData[sortedData.length - 1].createdAt
            : undefined,
      }
    },
    parseToActions: parseDepositHistoriesToActions,
    parseToAccountIds: parseDepositHistoriesToAccountIds,
    parseToSources: parseDepositHistoriesToSources,
  })
